import React, { useEffect, useState, FC } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import KeywordInput from "./KeywordInput";
import { useLocation } from "react-router";
import { useHistory } from "react-router-dom";
import { resetSearchTrips, searchTrips } from "functions/redux/listing/action";
import { RootStore } from "functions/redux/store";

export interface SearchFormProps {
    haveDefaultValue?: boolean;
}

// DEFAULT DATA FOR ARCHIVE PAGE
const defaultLocationValue = "Tokyo, Jappan";

const SearchForm: FC<SearchFormProps> = ({
    haveDefaultValue = false,
}) => {
    const search = useLocation().search;
    const keyword = new URLSearchParams(search).get("keyword");
    const { user } = useSelector((state: RootStore) => state);

    const [locationInputValue, setLocationInputValue] = useState(keyword ?? "");
    const dispatch = useDispatch();
    const history = useHistory();

    //
    useEffect(() => {
        if (haveDefaultValue) {
            setLocationInputValue(defaultLocationValue);
        }
    }, [haveDefaultValue]);
    //

    const { t } = useTranslation();

    const renderForm = () => {
        return (
            <form className="w-full relative flex flex-col md:flex-row md:items-center rounded-3xl lg:rounded-full shadow-xl dark:shadow-2xl bg-white dark:bg-neutral-900 divide-y divide-neutral-200 md:divide-y-0">
                <KeywordInput
                    defaultValue={locationInputValue}
                    onChange={(e) => setLocationInputValue(e)}
                    placeHolder={t('keyword')}
                    desc={t('keyword_plc')}
                />

                <div className="px-4 py-4 lg:py-0">
                    <button
                        type="submit"
                        onClick={() => {
                            dispatch(resetSearchTrips());
                            dispatch(searchTrips(locationInputValue === '' ? 'any' : locationInputValue, user.credential, null, null, 1));
                            history.push({
                                pathname: '/search',
                                search: `?keyword=${locationInputValue}`,
                            })
                        }}
                        className="h-14 md:h-16 w-full md:w-16 rounded-full bg-primary-6000 hover:bg-primary-700 flex items-center justify-center text-neutral-50 focus:outline-none"
                    >
                        <span className="mr-3 md:hidden">Search</span>
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            className="h-6 w-6"
                            fill="none"
                            viewBox="0 0 24 24"
                            stroke="currentColor"
                        >
                            <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth={1.5}
                                d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
                            />
                        </svg>
                    </button>
                </div>
            </form>
        );
    };

    return renderForm();
};

export default SearchForm;
